<template>

    <div class="score-debugger">
        <b>{{ (debuggr.completed == 1) ? '✔ ' : '    ' }}</b> <b>{{ (debuggr.score) ? debuggr.score : 0 }}</b>&thinsp;pts  <b class="score-debugger--trigger" v-if="debuggr.mesures" @dblclick="selectTipText()">
            M
            <div class="score-debugger__layer" ref="tip">
                <pre>{{ debuggr.destination }}: <strong>{{ mesures }}</strong></pre>
            </div>
        </b>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'score-debugger',

    props: {
        uukey: String,
    },

    computed: {
        mesures()
        {
            if (this.debuggr && this.debuggr.mesures)
            {
                const str = JSON.parse(this.debuggr.mesures);
                return str.join(', ');
            }
            return '';
        },

        ...mapState({
            debuggr(state)
            {
                return state.debugger[this.uukey] || {};
            },
        }),
    },
    methods: {

        selectTipText()
        {
            const selectElementContents = function(el) {
                const range = document.createRange();
                range.selectNodeContents(el);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
            selectElementContents(this.$refs.tip);
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/score-debugger.vue